import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FilterMenuFormConfig, FilterMenuService } from './../../services/filter-menu.service';
import { keys } from 'lodash';

@Component({
  selector: 'app-active-filters',
  templateUrl: './active-filters.component.html',
  styleUrls: ['./active-filters.component.scss'],
})
export class ActiveFiltersComponent implements OnInit {

  @Input() config: FilterMenuFormConfig;
  @Output() onSelect: EventEmitter<Object> = new EventEmitter();

  public selectedFiltersCount: number;

  constructor(private filterMenuService: FilterMenuService) {
  }

  ngOnInit() {
    this.calculateActiveFilters();
  }

  public async open() {
    this.config.data = await this.filterMenuService.open(this.config);
    this.onSelect.emit(this.config.data);
    this.calculateActiveFilters();
  }

  private calculateActiveFilters() {
    this.selectedFiltersCount = keys(this.config.data).length;
  }
}
